import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-medium);
	align-items: center;
	min-width: 0;
`;
